import useSimpleList from "core/features/shared/useSimpleList";
import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";

function SelectTipoVotacao({ ...rest }: SelectBaseAntdProps) {
  const { isLoading, data } = useSimpleList("v1/tipo-votacao");

  return (
    <SelectBaseAntd
      loading={isLoading}
      size="large"
      {...rest}
      showSearch
      allowClear
      optionFilterProp="label"
      options={data?.map((item) => ({
        value: item.id,
        label: item.nome,
      }))}
      {...rest}
    />
  );
}

export default SelectTipoVotacao;
